import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { useEffect, useState, type JSX } from 'react';

/**
 * B19 pwa-mobile (CF-1940) — the app requires a connection (zero offline cache).
 * Shows a persistent "no connection" notice when the browser goes offline.
 */
export function OfflineBanner(): JSX.Element {
  const [offline, setOffline] = useState(typeof navigator !== 'undefined' && !navigator.onLine);

  useEffect(() => {
    const goOffline = (): void => setOffline(true);
    const goOnline = (): void => setOffline(false);
    window.addEventListener('offline', goOffline);
    window.addEventListener('online', goOnline);
    return () => {
      window.removeEventListener('offline', goOffline);
      window.removeEventListener('online', goOnline);
    };
  }, []);

  return (
    <Snackbar open={offline} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
      <Alert severity="warning" variant="filled" sx={{ width: '100%' }}>
        No connection — please reconnect.
      </Alert>
    </Snackbar>
  );
}
